import { MasterDataContainer } from '../../dataAccess/masterDataContainer';
import { UserInfoCacheViewModel } from './userInfoCacheViewModel';

export class UserInfoCacheContainer extends MasterDataContainer<UserInfoCacheViewModel> {
    constructor(models: Array<UserInfoCacheViewModel>, dataYear: number, version: Date) {
        super(models, dataYear, version);
    }
}
